/**
 * Document-unique DOM ids for the Edit-with-AI surface. At most one EditWithAI
 * may be mounted at a time — Editor / AI Studio / Batch Studio are mutually
 * exclusive routes.
 */
export const EDIT_WITH_AI_TEXTAREA_ID = 'edit-with-ai-textarea'
export const EDIT_WITH_AI_POST_GENERATION_ID = 'try-again-group'
/** Batch Studio's "Edit with AI" menu item — exempt from the panel's outside-click
 *  close, since that button already toggles it. */
export const BATCH_EDIT_WITH_AI_TRIGGER_ID = 'batch-edit-with-ai-trigger'
